import ReImg from '@/components/Image/ReImg.vue';

const allGlobalComponents = {
    ReImg,
};

export default {
    install(app) {
        // 注册项目的全部公共组件
        Object.values(allGlobalComponents).forEach((component) => {
            if (typeof component.name === 'string') {
                app.component(component.name, component);
            } else {
                console.error(`Component does not have a valid "name" property.`);
            }
        });
    },
};
